import React from "react"
import { Link } from "react-router-dom"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"

import { USER_NAVIGATION } from "../../config"

/**
 * This is an abstracted part of the menu shared by static and
 * dynamic menus.
 */

interface Props {
  handleRouteClicked: (route: string) => void
}

const MenuDrawerItems = ({ handleRouteClicked }: Props) => (
  <>
    {USER_NAVIGATION.filter((item) => item.showInDrawer).map((item) => (
      <ListItem
        button
        component={Link}
        to={item.href}
        onClick={() => handleRouteClicked(item.href)}
      >
        <ListItemText primary={item.label} />
      </ListItem>
    ))}
  </>
)

export default MenuDrawerItems
